$( document ).ready(function() {
    function fadeIn(el){
        el.classList.add('fadein');
        el.classList.remove('fadeout');
    }

    function fadeOut(el){
        el.classList.add('fadeout');
        el.classList.remove('fadein');
    }

    var fadeElement = document.getElementById('fixed_nav');
    if (fadeElement) {
        $(window).scroll(function(){
            if ($(this).scrollTop() > 300) {
                fadeIn(fadeElement);
            } else {
                fadeOut(fadeElement);
            }
        });
    }

    /*******************************************************************************
     *  Contrast Button
     ******************************************************************************/

    $('#toggle-contrast').on('click', function() {
        if($('html').attr('data-bs-theme') === 'dark') {
            $('html').attr('data-bs-theme', 'light');
            document.cookie = "contrast=light; path=/; max-age=31536000"; // 1 year
        } else {
            $('html').attr('data-bs-theme', 'dark');
            document.cookie = "contrast=dark; path=/; max-age=31536000"; // 1 year
        }
    });

    $('#toggle-contrast-mobile').on('click', function() {
        if($('html').attr('data-bs-theme') === 'dark') {
            $('html').attr('data-bs-theme', 'light');
            document.cookie = "contrast=light; path=/; max-age=31536000"; // 1 year
        } else {
            $('html').attr('data-bs-theme', 'dark');
            document.cookie = "contrast=dark; path=/; max-age=31536000"; // 1 year
        }
    });

    let contrastCookie = document.cookie.split('; ').find(row => row.startsWith('contrast='));
    if(contrastCookie) {
        contrastCookie = contrastCookie.split('=')[1];
        $('html').attr('data-bs-theme', contrastCookie);
    }

    /*******************************************************************************
     *  Disable click on edit cookies button
     ******************************************************************************/
    $('#editCookies').on('click', function(e) {
       e.preventDefault();
    });
});
